import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    backgroundColor: red[600],
    '&:hover': {
      backgroundColor: red[900]
    }
  }
}));

const DeleteButton = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const { t } = useTranslation('common');
  return (
    <Button
      {...rest}
      variant="contained"
      className={clsx(classes.root, className)}
      startIcon={<DeleteIcon />}
    >
      {t('button.delete')}
    </Button>
  );
};
DeleteButton.propTypes = {
  className: PropTypes.string
};

export default DeleteButton;
